import { SafeHtml } from '@angular/platform-browser';

export interface DialogData {
  title?: string;
  content: string | SafeHtml;
  buttons: DialogButton[];
  style?: string;
  disableClose?: boolean;
  reason?: string;
}

export interface DialogButton {
  label: string;
  style?: string;
  focused?: boolean;
  icon?: string;
  class?: string;
  withValidation?: boolean;
}

/**
 * Default button for the dialog component.
 */
export const defaultDialogButtons: DialogButton[] = [{
  label: 'Close',
  focused: true,
  style: '',
  withValidation: false,
}];
